import moment from 'moment';
import jquery from 'jquery';
import 'moment-timezone';

declare global {
  interface Window {
    jQuery: typeof jquery;
    $: typeof jquery;
    moment: typeof moment;
  }
}

window.jQuery = window.$ = jquery;
window.moment = moment;

export function bootstrapApp(): void {
  moment.tz.guess();
}

bootstrapApp();
